const LOADING_TEXT = "...";

function translationMissing(key) {
  const message = `Translation missing: ${key}`;

  console.error(message);

  return message;
}

export default {
  hasLocalisation(state) {
    return (key) => {
      return !!state.content[key];
    };
  },

  localised(state, getters) {
    return (key) => {
      return (
        state.content[key] ||
        (getters.loadingAjax ? LOADING_TEXT : translationMissing(key))
      );
    };
  },
  loadingImage(state) {
    return state.activeImageRequests > 0;
  },

  loadingAudio(state) {
    return state.activeAudioRequests > 0;
  },

  loadingAjax(state) {
    return state.activeAjaxRequests > 0;
  },

  loadingVideo(state) {
    return state.activeVideoRequests > 0;
  },

  loading(_state, getters) {
    return (
      getters.loadingImage ||
      getters.loadingAjax ||
      getters.loadingAudio ||
      getters.loadingVideo
    );
  },

  getPreloadedAsset: (state) => (path) => {
    return state.preloadedAssets[path];
  },

  experimentMode: (state) => {
    return state.appMode === "experiment";
  },

  screenMode: (state) => {
    return state.screenMode;
  },
  sessionId: (state) => {
    return state.sessionId;
  },
  videoStatus(state) {
    const subtitleKey = state.trackingData.mediaKey;
    const videoStateMap = {
      "intro.subtitles": "intro",
      "spectrogram.subtitles": "training video",
      "science_intro_intro.subtitles": "science_intro_philippines",
      "science_intro.subtitles": "science_philippines",
      "spectrogram_intro.subtitles": "spectrogram_training",
      "outro.subtitles": "outro",
    };

    let currentVideoState = videoStateMap[subtitleKey] || "";
    return currentVideoState;
  },
};
